import { studentConstants } from '../constants';
import { studentService } from '../services';
import { showToast } from '../services/toast';

export const studentActions = {
    fetchStudentsList
};

function fetchStudentsList(classId) {
    return dispatch => {
        dispatch(request());

        studentService.fetchStudentsList(classId)
            .then(
                response => {
                    dispatch(success(response.data));
                    return response;
                },
                error => {
                    dispatch(failure(error));
                    showToast(error.toString(), 'error');
                }
            );
    };

    function request() { return { type: studentConstants.FETCH_STUDENTSLIST_REQUEST } }
    function success(studentslist) { return { type: studentConstants.FETCH_STUDENTSLIST_SUCCESS, studentslist } }
    function failure(error) { return { type: studentConstants.FETCH_STUDENTSLIST_FAILURE, error } }
}